module.exports = __webpack_public_path__ + "img/page2-bg-phone.3140e3f4.png";